import styled from 'styled-components'

import MainLayout from '../../layouts/MainLayout'
import Breadcrumb from '../../components/Breadcrumb'

export const Layout = styled(MainLayout)``
export const BreadcrumbElement = styled(Breadcrumb)`
  margin-top: 3.5rem;
`
